import { useState, useEffect } from "react";
import logger from "../../../util/logger";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import classnames from "classnames";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";
import { Button, Modal, ModalBody } from "reactstrap";

import { FaChevronDown, FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

import { useTranslation } from "react-i18next";

function JoinALeaguePage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [soccerOrigins, setSoccerOrigins] = useState();
  const [footballOrigins, setFootballOrigins] = useState();
  // eslint-disable-next-line
  const [leagues, setLeagues] = useState();
  const fetchLeagues = async () => {
    try {
      setIsLoading(true);

      let fetchedLeagues = [];

      const q = query(collection(db, "leagues"));
      const docs = await getDocs(q);

      let fetchedSoccerOrigins = [];
      let fetchedFootballOrigins = [];

      docs.forEach((doc) => {
        const newLeague = doc.data();
        if (newLeague.name !== "Test League") {
          if (newLeague.sportCategory === "SOCCER") {
            logger.debug(newLeague.name);
            if (!fetchedSoccerOrigins.includes(newLeague.origin)) {
              fetchedSoccerOrigins.push(newLeague.origin);
            }
          } else if (newLeague.sportCategory === "FOOTBALL") {
            if (!fetchedFootballOrigins.includes(newLeague.origin)) {
              fetchedFootballOrigins.push(newLeague.origin);
            }
          }
          fetchedLeagues.push(newLeague);
        }
      });

      setSoccerOrigins(fetchedSoccerOrigins);
      setFootballOrigins(footballOrigins);
      setLeagues(fetchedLeagues);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching leagues");
    }
  };

  useEffect(() => {
    if (user) {
      fetchLeagues();
    }
    // eslint-disable-next-line
  }, [user]);

  const [groups, setGroups] = useState();
  const fetchGroups = async () => {
    try {
      setIsLoading(true);

      let fetchedGroups = [];

      const q = query(collection(db, "groups"));
      const docs = await getDocs(q);

      docs.forEach((doc) => {
        const newGroup = doc.data();
        if (!fetchedGroups.includes(newGroup.league)) {
          fetchedGroups.push(newGroup.league);
        }
      });

      setGroups(fetchedGroups);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching groups");
    }
  };

  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line
  }, []);

  const [activeSport, setActiveSport] = useState();
  const toggleActiveSport = (sport) => {
    if (sport === activeSport) {
      setActiveSport();
    } else {
      setActiveSport(sport);
    }
  };

  const [sportOriginModalIsVisible, setSportOriginModalIsVisible] =
    useState(false);
  const [activeSportOrigin, setActiveSportOrigin] = useState();
  const toggleSportOriginModal = (sport) => {
    setSportOriginModalIsVisible(!sportOriginModalIsVisible);
    setActiveSportOrigin(sport);
  };

  const [activeSoccerOriginFilter, setActiveSoccerOriginFilter] = useState();
  const toggleActiveSoccerOrigin = (origin) => {
    if (origin === activeSoccerOriginFilter) {
      setActiveSoccerOriginFilter();
      toggleSportOriginModal();
    } else {
      setActiveSoccerOriginFilter(origin);
      toggleSportOriginModal();
    }
  };
  const clearActiveSoccerOrigin = () => {
    setActiveSoccerOriginFilter();
    toggleSportOriginModal();
  };

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // eslint-disable-next-line
  const [usersRooms, setUsersRooms] = useState();
  const fetchUsersLeagues = async () => {
    try {
      setIsLoading(true);

      let fetchedRooms = [];

      const q = query(
        collection(db, "rooms"),
        where("memberUids", "array-contains", user?.uid)
      );
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newRoom = doc.data();
        fetchedRooms.push(newRoom);
      });

      setUsersRooms(fetchedRooms);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user's leagues");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUsersLeagues();
    }
    // eslint-disable-next-line
  }, [user]);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="playPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("joinALeague").toUpperCase()}
      </h1>
      <div>
        <ScrollMenu>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeSport === "SOCCER",
            })}
            onClick={() => toggleActiveSport("SOCCER")}
          >
            <p>{t("soccer").toUpperCase()}</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeSport === "FOOTBALL",
            })}
            onClick={() => toggleActiveSport("FOOTBALL")}
          >
            <p>{t("football").toUpperCase()}</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeSport === "BASEBALL",
            })}
            onClick={() => toggleActiveSport("BASEBALL")}
          >
            <p>{t("baseball").toUpperCase()}</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeSport === "HOCKEY",
            })}
            onClick={() => toggleActiveSport("HOCKEY")}
          >
            <p>{t("hockey").toUpperCase()}</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeSport === "RACING",
            })}
            onClick={() => toggleActiveSport("RACING")}
          >
            <p>{t("racing").toUpperCase()}</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeSport === "BASKETBALL",
            })}
            onClick={() => toggleActiveSport("BASKETBALL")}
          >
            <p>{t("basketball").toUpperCase()}</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeSport === "MMA",
            })}
            onClick={() => toggleActiveSport("MMA")}
          >
            <p>{t("mma").toUpperCase()}</p>
          </div>
          {/* <div className={classnames('shopCategoriesMenuItem',{active: (activeSport === 'COLLEGE FOOTBALL')})} onClick={() => toggleActiveSport('COLLEGE FOOTBALL')}>
            <p>
              COLLEGE FOOTBALL
            </p>
          </div>
          <div className={classnames('shopCategoriesMenuItem',{active: (activeSport === 'COLLEGE BASKETBALL')})} onClick={() => toggleActiveSport('COLLEGE BASKETBALL')}>
            <p>
              COLLEGE BASKETBALL
            </p>
          </div> */}
        </ScrollMenu>
        <div style={{ marginTop: "1rem" }}>
          {!activeSport || activeSport === "SOCCER" ? (
            <div className="joinALeaguePageSection">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <h1>{t("soccer").toUpperCase()}</h1>
                <div
                  onClick={() => toggleSportOriginModal("SOCCER")}
                  className="joinALeagueOriginSelector"
                >
                  <p>
                    {activeSoccerOriginFilter
                      ? activeSoccerOriginFilter
                      : "Origin"}
                    <FaChevronDown style={{ marginLeft: "0.5rem" }} />
                  </p>
                </div>
              </div>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  leagues?.map((league) => {
                    if (league.sportCategory === "SOCCER") {
                      if (groups?.includes(league.name)) {
                        if (activeSoccerOriginFilter) {
                          if (league.origin === activeSoccerOriginFilter) {
                            return (
                              <div
                                onClick={() =>
                                  navigate(`/play/leagues/${league.uid}`)
                                }
                                className="leagueCard"
                              >
                                <div className="leagueCardImageContainer">
                                  <img
                                    alt="productImage"
                                    src={
                                      league.image
                                        ? league.image
                                        : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    padding: "1rem",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <p className="leagueCardName">
                                    {league.name}
                                  </p>
                                  <p className="leagueCardOrigin">
                                    {league.origin}
                                  </p>
                                </div>
                              </div>
                            );
                          }
                        } else {
                          return (
                            <div
                              onClick={() =>
                                navigate(`/play/leagues/${league.uid}`)
                              }
                              className="leagueCard"
                            >
                              <div className="leagueCardImageContainer">
                                <img
                                  alt="productImage"
                                  src={
                                    league.image
                                      ? league.image
                                      : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                  }
                                />
                              </div>
                              <div
                                style={{
                                  padding: "1rem",
                                  paddingTop: "0.5rem",
                                }}
                              >
                                <p className="leagueCardName">{league.name}</p>
                                <p className="leagueCardOrigin">
                                  {league.origin}
                                </p>
                              </div>
                            </div>
                          );
                        }
                      }
                    }
                  })
                }
              </ScrollMenu>
            </div>
          ) : null}
          <Modal
            id="sportOriginModal"
            isOpen={sportOriginModalIsVisible}
            toggle={toggleSportOriginModal}
            size={"lg"}
          >
            <ModalBody>
              <div className="modalHeader">
                <div></div>
                <IoClose onClick={toggleSportOriginModal} />
              </div>
              <div>
                <h1>{t("chooseOrigin").toUpperCase()}</h1>
                <div style={{ marginTop: "1rem" }}>
                  {activeSportOrigin === "SOCCER"
                    ? soccerOrigins?.map((origin) => {
                        return (
                          <p
                            onClick={() => toggleActiveSoccerOrigin(origin)}
                            className={classnames("sportOriginModalOption", {
                              active: activeSoccerOriginFilter === origin,
                            })}
                          >
                            {origin}
                          </p>
                        );
                      })
                    : null}
                </div>
                <Button
                  onClick={clearActiveSoccerOrigin}
                  className="primaryBtn"
                  style={{ marginTop: "0.5rem" }}
                >
                  {t("clear").toUpperCase()}
                </Button>
              </div>
            </ModalBody>
          </Modal>
          {!activeSport || activeSport === "FOOTBALL" ? (
            <div className="joinALeaguePageSection">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <h1>{t("football").toUpperCase()}</h1>
                {/* <div onClick={() => toggleSportOriginModal('FOOTBALL')} className='joinALeagueOriginSelector'>
                    <p>
                      {activeSoccerOriginFilter ? activeSoccerOriginFilter : 'Origin'}
                      <FaChevronDown style={{marginLeft: '0.5rem'}} />
                    </p>
                  </div> */}
              </div>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  leagues?.map((league) => {
                    if (league.sportCategory === "FOOTBALL") {
                      if (groups?.includes(league.name)) {
                        if (activeSoccerOriginFilter) {
                          if (league.origin === activeSoccerOriginFilter) {
                            return (
                              <div
                                onClick={() =>
                                  navigate(`/play/leagues/${league.uid}`)
                                }
                                className="leagueCard"
                              >
                                <div className="leagueCardImageContainer">
                                  <img
                                    alt="productImage"
                                    src={
                                      league.image
                                        ? league.image
                                        : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    padding: "1rem",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <p className="leagueCardName">
                                    {league.name}
                                  </p>
                                  <p className="leagueCardOrigin">
                                    {league.origin}
                                  </p>
                                </div>
                              </div>
                            );
                          }
                        } else {
                          return (
                            <div
                              onClick={() =>
                                navigate(`/play/leagues/${league.uid}`)
                              }
                              className="leagueCard"
                            >
                              <div className="leagueCardImageContainer">
                                <img
                                  alt="productImage"
                                  src={
                                    league.image
                                      ? league.image
                                      : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                  }
                                />
                              </div>
                              <div
                                style={{
                                  padding: "1rem",
                                  paddingTop: "0.5rem",
                                }}
                              >
                                <p className="leagueCardName">{league.name}</p>
                                <p className="leagueCardOrigin">
                                  {league.origin}
                                </p>
                              </div>
                            </div>
                          );
                        }
                      }
                    }
                  })
                }
              </ScrollMenu>
            </div>
          ) : null}
          {!activeSport || activeSport === "RACING" ? (
            <div className="joinALeaguePageSection">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <h1>{t("racing").toUpperCase()}</h1>
                {/* <div onClick={() => toggleSportOriginModal('FOOTBALL')} className='joinALeagueOriginSelector'>
                    <p>
                      {activeSoccerOriginFilter ? activeSoccerOriginFilter : 'Origin'}
                      <FaChevronDown style={{marginLeft: '0.5rem'}} />
                    </p>
                  </div> */}
              </div>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  leagues?.map((league) => {
                    if (league.sportCategory === "RACING") {
                      if (groups?.includes(league.name)) {
                        if (activeSoccerOriginFilter) {
                          if (league.origin === activeSoccerOriginFilter) {
                            return (
                              <div
                                onClick={() =>
                                  navigate(`/play/leagues/${league.uid}`)
                                }
                                className="leagueCard"
                              >
                                <div className="leagueCardImageContainer">
                                  <img
                                    alt="productImage"
                                    src={
                                      league.image
                                        ? league.image
                                        : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    padding: "1rem",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <p className="leagueCardName">
                                    {league.name}
                                  </p>
                                  <p className="leagueCardOrigin">
                                    {league.origin}
                                  </p>
                                </div>
                              </div>
                            );
                          }
                        } else {
                          return (
                            <div
                              onClick={() =>
                                navigate(`/play/leagues/${league.uid}`)
                              }
                              className="leagueCard"
                            >
                              <div className="leagueCardImageContainer">
                                <img
                                  alt="productImage"
                                  src={
                                    league.image
                                      ? league.image
                                      : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                  }
                                />
                              </div>
                              <div
                                style={{
                                  padding: "1rem",
                                  paddingTop: "0.5rem",
                                }}
                              >
                                <p className="leagueCardName">{league.name}</p>
                                <p className="leagueCardOrigin">
                                  {league.origin}
                                </p>
                              </div>
                            </div>
                          );
                        }
                      }
                    }
                  })
                }
              </ScrollMenu>
            </div>
          ) : null}
          {!activeSport || activeSport === "BASKETBALL" ? (
            <div className="joinALeaguePageSection">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <h1>{t("basketball").toUpperCase()}</h1>
                {/* <div onClick={() => toggleSportOriginModal('FOOTBALL')} className='joinALeagueOriginSelector'>
                    <p>
                      {activeSoccerOriginFilter ? activeSoccerOriginFilter : 'Origin'}
                      <FaChevronDown style={{marginLeft: '0.5rem'}} />
                    </p>
                  </div> */}
              </div>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  leagues?.map((league) => {
                    if (league.sportCategory === "BASKETBALL") {
                      if (groups?.includes(league.name)) {
                        if (activeSoccerOriginFilter) {
                          if (league.origin === activeSoccerOriginFilter) {
                            return (
                              <div
                                onClick={() =>
                                  navigate(`/play/leagues/${league.uid}`)
                                }
                                className="leagueCard"
                              >
                                <div className="leagueCardImageContainer">
                                  <img
                                    alt="productImage"
                                    src={
                                      league.image
                                        ? league.image
                                        : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    padding: "1rem",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <p className="leagueCardName">
                                    {league.name}
                                  </p>
                                  <p className="leagueCardOrigin">
                                    {league.origin}
                                  </p>
                                </div>
                              </div>
                            );
                          }
                        } else {
                          return (
                            <div
                              onClick={() =>
                                navigate(`/play/leagues/${league.uid}`)
                              }
                              className="leagueCard"
                            >
                              <div className="leagueCardImageContainer">
                                <img
                                  alt="productImage"
                                  src={
                                    league.image
                                      ? league.image
                                      : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                  }
                                />
                              </div>
                              <div
                                style={{
                                  padding: "1rem",
                                  paddingTop: "0.5rem",
                                }}
                              >
                                <p className="leagueCardName">{league.name}</p>
                                <p className="leagueCardOrigin">
                                  {league.origin}
                                </p>
                              </div>
                            </div>
                          );
                        }
                      }
                    }
                  })
                }
              </ScrollMenu>
            </div>
          ) : null}
          {!activeSport || activeSport === "BASEBALL" ? (
            <div className="joinALeaguePageSection">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <h1>{t("baseball").toUpperCase()}</h1>
                {/* <div onClick={() => toggleSportOriginModal('FOOTBALL')} className='joinALeagueOriginSelector'>
                    <p>
                      {activeSoccerOriginFilter ? activeSoccerOriginFilter : 'Origin'}
                      <FaChevronDown style={{marginLeft: '0.5rem'}} />
                    </p>
                  </div> */}
              </div>
              <ScrollMenu>
                {
                  // eslint-disable-next-line
                  leagues?.map((league) => {
                    if (league.sportCategory === "BASEBALL") {
                      if (groups?.includes(league.name)) {
                        if (activeSoccerOriginFilter) {
                          if (league.origin === activeSoccerOriginFilter) {
                            return (
                              <div
                                onClick={() =>
                                  navigate(`/play/leagues/${league.uid}`)
                                }
                                className="leagueCard"
                              >
                                <div className="leagueCardImageContainer">
                                  <img
                                    alt="productImage"
                                    src={
                                      league.image
                                        ? league.image
                                        : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    padding: "1rem",
                                    paddingTop: "0.5rem",
                                  }}
                                >
                                  <p className="leagueCardName">
                                    {league.name}
                                  </p>
                                  <p className="leagueCardOrigin">
                                    {league.origin}
                                  </p>
                                </div>
                              </div>
                            );
                          }
                        } else {
                          return (
                            <div
                              onClick={() =>
                                navigate(`/play/leagues/${league.uid}`)
                              }
                              className="leagueCard"
                            >
                              <div className="leagueCardImageContainer">
                                <img
                                  alt="productImage"
                                  src={
                                    league.image
                                      ? league.image
                                      : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                                  }
                                />
                              </div>
                              <div
                                style={{
                                  padding: "1rem",
                                  paddingTop: "0.5rem",
                                }}
                              >
                                <p className="leagueCardName">{league.name}</p>
                                <p className="leagueCardOrigin">
                                  {league.origin}
                                </p>
                              </div>
                            </div>
                          );
                        }
                      }
                    }
                  })
                }
              </ScrollMenu>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default JoinALeaguePage;
